export function mapStoryAssets(storyAssets) {
  let mappedStoryAssets = storyAssets.map(storyAsset => {
    let newStoryAsset = {
      id: storyAsset._id,
      link: storyAsset.asset.link,
      type: storyAsset.asset.type,
      annotations: storyAsset.annotations,
      caption: storyAsset.caption || '',
      text: storyAsset.asset.text,
      cleanText: storyAsset.asset.cleanText
    }

    newStoryAsset = addAssetType(newStoryAsset)

    return newStoryAsset
  })

  mappedStoryAssets = combineInlineAds(mappedStoryAssets)
  return combineBannerAds(mappedStoryAssets)
}

export function mapAssets(assets) {
  let mappedStoryAssets = assets.map(asset => {
    let newAsset = {
      id: asset._id,
      link: asset.link,
      type: asset.type,
      annotations: asset.annotations,
      caption: asset.caption || '',
      text: asset.text,
      cleanText: asset.cleanText
    }

    newAsset = addAssetType(newAsset)

    return newAsset
  })

  mappedStoryAssets = combineInlineAds(mappedStoryAssets)
  return combineBannerAds(mappedStoryAssets)
}

export function addAssetType(asset) {
  asset.isImage = asset.type === 'IMAGE'
  asset.isVideo = asset.type === 'VIDEO'
  asset.isYT = asset.type === 'YOUTUBE'
  asset.isAudio = asset.type === 'AUDIO'
  asset.isText = asset.type === 'TEXT'
  asset.isPDF = asset.type === 'PDF'
  asset.isBannerAd = isBannerAd(asset)
  asset.isInlineAd = isInlineAd(asset)

  if(asset.isInlineAd) {
    asset.type = 'INLINE_AD'
  }

  if(asset.isBannerAd) {
    asset.type = 'BANNER_AD'
  }

  if(isAd(asset)) {
    asset.isImage = false
  }

  return asset
}

function isAd(asset) {
  return asset.isInlineAd || asset.isBannerAd
}

function isBannerAd(asset) {
  return isAdType(asset, 'BANNER-AD')
}

function isInlineAd(asset) {
  return isAdType(asset, 'AD')
}

function isAdType(asset, adType) {
  return !!(asset.caption && asset.caption.startsWith(adType))
}

export function combineInlineAds(assets) {
  return adCombiner('isInlineAd', assets)
}

export function combineBannerAds(assets) {
  return adCombiner('isBannerAd', assets)
}

function adCombiner(key, assets) {
  const newAssets =
    assets
      .reduce((acc, asset) => combine(key, acc, asset), [])

  return newAssets
}

function combine(key, acc, asset) {
  let row

  if(asset[key]) {
    const ad = getAd(asset)
    row = getRow(key, asset, acc)
    row.ads.push(ad)
  } else {
    row = asset
  }

  acc.push(row)

  return acc
}

function getAd(asset) {
  const href = parseHref(asset.caption)
  const imageUrl = asset.link

  return { imageUrl, href }
}

function getRow(key, asset, acc) {
  const previous = acc[acc.length - 1] || { isInlineAd: false }
  let row = null

  if(previous[key]) {
    row = acc.pop()
  } else {
    row = asset
    row.ads = []
  }

  return row
}

export function parseHref(caption) {
  if(!caption) {
    return ''
  } else if(caption.startsWith('AD-')) {
    const parts = caption.split('AD-')
    return parts[1]
  } else if(caption.startsWith('BANNER-AD-')) {
    const parts = caption.split('BANNER-AD-')
    return parts[1]
  } else {
    return ''
  }
}
